import { Avatar, Typography } from '@material-ui/core';

const TeamMemberCard = ({
  name,
  position,
  description,
  avatarSrc,
  avatarInitial,
  avatarAlt,
  isRtl = false,
}) => {
  return (
    <div className="p-5 text-center flex flex-col items-center h-full max-w-[240px] mx-auto">
      <div className="mb-4 flex justify-center">
        {avatarSrc ? (
          <Avatar
            src={avatarSrc}
            alt={avatarAlt || name}
            className="w-28 h-28 team-avatar"
            style={{
              width: '112px',
              height: '112px',
            }}
            imgProps={{
              className: 'team-avatar-img',
              style: {
                objectFit: 'cover',
                objectPosition: 'center 30%',
              },
            }}
          />
        ) : (
          <Avatar
            alt={avatarAlt || name}
            className="w-28 h-28"
            style={{
              width: '112px',
              height: '112px',
              backgroundColor: '#78716c',
              fontSize: '3rem',
              fontWeight: 'bold',
            }}
          >
            {avatarInitial || (isRtl ? name.charAt(0) : name.charAt(0))}
          </Avatar>
        )}
      </div>
      <Typography
        variant="h6"
        component="h3"
        className="mb-1 text-black leading-snug"
        style={{ fontWeight: 700 }}
      >
        {name}
      </Typography>
      <Typography
        variant="body2"
        component="p"
        className="mb-4"
        style={{ color: '#063447', fontWeight: 600 }}
      >
        {position}
      </Typography>
      <Typography variant="body2" className="text-black leading-relaxed whitespace-pre-line">
        {description}
      </Typography>
    </div>
  );
};

export default TeamMemberCard;
